module.exports = __webpack_public_path__ + "static/media/savio2.4e35223e.jpg";